import { reducerCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelperV2';
import { actionTypes } from '../actions/portaliIndicatoriHotels';
import { createHandlers } from '../../../helpers/portaleModuleHelper';

export const DEFAULT_STATE = helper.createDefaultState();

const handlers = createHandlers(actionTypes, {
    items: 'data.data',
    total: 'data.meta.total'
});

export default reducerCreator.createReducer(handlers, DEFAULT_STATE);

export const selectors = reducerCreator.createSelectors('portaliIndicatoriHotels');